import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SubcategoryGrid from '../components/Workwear/SubcategoryGrid';

const unslug = (slug) => {
  if (!slug) return '';
  const s = slug.replace(/-/g, ' ').replace(/\b\w/g, (m) => m.toUpperCase());
  // restore common punctuation variants if needed
  return s
    .replace(/T Shirts/i, 'T-Shirts')
    .replace(/Polo Shirts/i, 'Polo Shirts');
};

const WorkwearSubcategory = () => {
  const { t } = useTranslation();
  const { subcategory } = useParams();
  const label = useMemo(() => unslug(subcategory), [subcategory]);

  return (
    <section className="px-4 sm:px-6 xl:px-8 pb-20 pt-24 md:pb-[120px]">
      <div className="max-w-[1300px] mx-auto">
        <h1 className="text-center text-[32px] libre-baskerville sm:text-[57px] font-normal leading-[40px] sm:leading-[81px] text-[#1D1D1F]">
          {t(`categories.${label}`, label)}
        </h1>
        <div className="mt-10">
          <SubcategoryGrid subcategory={label} />
        </div>
      </div>
    </section>
  );
};

export default WorkwearSubcategory;
